import React from 'react'

function FederatedSignIn() {
  return (
    <div>
        
    </div>
  )
}

export default FederatedSignIn
